import React from 'react';
import Elevation, { ElevationProps } from 'components/Elevation';

import Styled from './styles';

const ELEVATION_INDEX = 3;

export interface CircularProgressIndicatorIndeterminateOverlayProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the CircularProgressIndicatorIndeterminateOverlay, consider using `CircularProgressIndicatorIndeterminate` */
  children: React.ReactNode;
  /** Size of the overlay in pixels. */
  overlaySize?: number;
  /** Override the Elevation properties. See Elevation component for details. */
  elevationProps?: Partial<ElevationProps>;
}

/**
 CircularProgressIndicatorIndeterminateOverlay, any other props than explicitly defined will be provided to the `overlay` wrapper wrapped by Elevation component.
 */
const CircularProgressIndicatorIndeterminateOverlay = (props: CircularProgressIndicatorIndeterminateOverlayProps) => {
  const {
    children,
    overlaySize,
    elevationProps,
    ...otherProps
  } = props;
  return (
    <Elevation
      style={{ borderRadius: '50%' }}
      elevationIndex={ELEVATION_INDEX}
      {...elevationProps}
    >
      <Styled.Overlay overlaySize={overlaySize} {...otherProps}>
        {children}
      </Styled.Overlay>
    </Elevation>
  );
};

CircularProgressIndicatorIndeterminateOverlay.defaultProps = {
  overlaySize: 26,
  elevationProps: {}
};

CircularProgressIndicatorIndeterminateOverlay.displayName = 'CircularProgressIndicatorIndeterminateOverlay';

export default CircularProgressIndicatorIndeterminateOverlay;